<template>
  <div class="cb-body__wrap">
    <cart-common :custom-class="'cb-body__content'"></cart-common>
    <div class="cb-body__footer" v-if="!editMode">
      <cb-notes :custom-class="'cb-section'" :type="'info'" :message="cartNote"></cb-notes>
      <button-field :attr="'cart_submit'" @next="next" :custom-class="'primary'" :showLoader="showLoader">
        {{t('cart.next')}} <i class="icon-long-arrow-right"></i>
      </button-field>
      </div>
  </div>
</template>
<script type="text/javascript">
import {
  mapGetters
} from "vuex"
import CartCommon from "@/components/modules/hosted-pages/CartCommon"
import CartMixin from "@/mixins/cart-mixin"
import Notes from "@/components/collections/elements/Notes"
import Button from "@/components/collections/form/ButtonComponent"
export default {
  mixins: [CartMixin],
  mounted() {
    if ((this.skip_cart || this.one_screen_checkout) && !this.editMode) {
      this.$router.replace({
        name: this.current_checkout_step
      });
    }
  },
  data() {
    return {
      showLoader: false,
    }
  },
  computed: {
    ...mapGetters(
      [
        'authenticated',
        'authType',
        'current_checkout_step',
        'is_hp_from_plan',
        'email_requested',
        'one_screen_checkout',
        'hp_loaded',
        'skip_cart'
      ]
    ),
    editMode() {
      return this.$route.query.mode == "edit";
    }
  },
  components: {
    'cart-common': CartCommon,
    'button-field': Button,
    'cb-notes': Notes
  },
  methods: {
    next(event) {
      this.showLoader = true;
      if (!this.hp_loaded) {
        this.$store.state.checkout.loading.then(() => {
          this._next();
        });
      } else {
        this._next();
      }
    },
    _next() {
      if (this.is_hp_from_plan && this.authType == "email" && this.email_requested && !this.authenticated) {
        this.$router.push({
          name: "check_user"
        });
      } else {
        // if customer is authenticated or
        // if hp request source is from api(new customer)
        // if hp request source is from plan and auth type is email
        this.$router.push({
          name: this.current_checkout_step
        });
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// Cart.vue?05bfae7a